export const routes = {
  tracker: '/tracker',
  profile: '/profile',
  login: '/login',
  register: '/register',
};
